<template>
  <div>
    <el-button
      style="cursor: pointer"
      type="info"
      circle
      :loading="listLoading"
      icon="el-icon-message"
      @click="handleGetList"
    ></el-button>
    <el-dialog
      top="2%"
      width="80%"
      :visible.sync="dialogTableVisible"
      :title="`活動推播歷史紀錄（${list.length}）`"
    >
      <div style="position: relative; min-height: 300px; height: 100%">
        <el-table
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          height="100%"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="資料ID" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="推播時間" width="160">
            <template slot-scope="scope">
              <el-tag effect="dark" type="info">{{ scope.row.recordDate }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="left" label="旅遊團" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.travelID"
                >(ID:{{ scope.row.travelID }}){{ scope.row.travelName }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="center" label="使用者名稱" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.userName }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="優惠券連結" width="120">
            <template slot-scope="scope">
              <a :href="JSON.parse(scope.row.data).url" target="_blank">
                <div class="coupon-link">
                  <span>優惠券連結</span>
                  <el-icon name="link" style="margin-left: 2px"></el-icon>
                </div>
              </a>
            </template>
          </el-table-column>

          <el-table-column align="left" label="推播標題" width="155">
            <template slot-scope="scope">
              <span>{{ scope.row.subject }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="推播內文" width="450">
            <template slot-scope="scope">
              <span>{{ scope.row.content }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="成功筆數" width="80" fixed="right">
            <template slot-scope="scope">
              <span v-if="scope.row.successCount == 0"></span>
              <el-tag v-else effect="dark" type="success">{{ scope.row.successCount }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="失敗筆數" width="80" fixed="right">
            <template slot-scope="scope">
              <span v-if="scope.row.failureCount == 0"></span>
              <el-tag v-else effect="dark" type="danger">{{ scope.row.failureCount }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { notificationTravelsLog } from '@/api/notification'

export default {
  name: 'NotificationHistory',
  data() {
    return {
      listLoading: false,
      dialogTableVisible: false,
      list: [],
    }
  },
  methods: {
    // 取得活動推播歷史紀錄
    async handleGetList() {
      this.listLoading = true
      await notificationTravelsLog()
        .then(res => {
          this.list = res.data
          this.dialogTableVisible = true
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.coupon-link {
  color: #1890ff;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 75%;
  }
}
</style>
